export const normalPlaceForGroups = {
    wo_spec: {
        2: 15,
        3: 15,
        4: 20,
        5: 20,
        6: 20,
        11:15,
        14:15,
        default: 15 
    },
    short: 10,
    spec:{
        "з короткотривалим і цілодобовим перебуванням дітей":10,  
        "із складними вадами розвитку, глухі, сліпі":6,
        "зі зниженням слуху":8,
        "з порушенням опорно-рухового апарату":8,
        "глибоко розумово відсталі":8,
        "з важкими порушеннями мови":10,
        "з затримкою психічного розвитку":10,
        "із затримкою психічного розвитку": 10,
        "із зниженням зору, косоокістю і амбліопією":10,
        "розумово відсталих":10, 
        "хворих на сколіоз":10,
        "з фонетико-фонематичним недорозвитком мови": 12,
        "Загальний недорозвиток мовлення": 10,
        "з розумовою відсталістю": 10,
        "з порушеннями слуху (глухих, зі зниженим слухом)": 8,
        "з хронічними неспецифічними захворюваннями органів дихання": 10,
        "Фонетико-фонематичне недорозвинення мови": 12,
        "з порушеннями опорно-рухового апарату":8,
        "з хворобами органів травлення": 10,
        "з порушеннями зору (сліпих, зі зниженим зором)": 10,
        "з латентною туберкульозною інфекцією та після вилікування від туберкульозу": 10,
        default: 10 
    },
    sanat:{
        1:15,
        2:15,
        3:15,
        9:15,
        10:15,
        11:15,
        12:15,
        13:15,
        14: 15,
        default: 20
    }
};

export const TYPE_SANAORNIY = 'Санаторна';

export const types_places = [
    {name:'Повного дня', value:'sleepingPlaces'},
    {name:'Короткотривалого перебування', value:'withoutBeds'},
    {name:'Інклюзія', value:'inclusive'},
    {name: 'Інклюзивно-короткотривалого перебування', value: 'inclusiveShort'}
];

export const periods_contr = [
    {name:'Місяць', value:1},
    {name:'Два місяця', value:2},
    {name:'Три місяця', value:3},
];

export const types_zdo = [
    "ЗДО", "дошкільний підрозділ"
];

export const types_grups = [
    "Функціональні", "Нефункціональні"
];

export const month_ukr = [
    'січень','лютий','березень','квітень','травень','червень',
    'липень','серпень','вересень','жовтень','листопад','грудень'
];

export const day_ua = [
    {t:'нд', col:'red'},
    {t:'пн'},
    {t:'вт'},
    {t:'ср'},
    {t:'чт'},
    {t:'пт'},
    {t:'сб', col:'red'}
];

export const groupTypes = [
    {
        "number": 1,
        "ageLimitFrom": 0,
        "ageLimitTo": 1,
        "description": "Перша група раннього віку — від двох місяців до року (до 10 осіб)"
    },
    // ... остальные типы групп
];